module.exports = __webpack_public_path__ + "img/_icon-savings.037a67ca.svg";